import { render, staticRenderFns } from "./BooleanFormat.vue?vue&type=template&id=8addf7b2"
import script from "./BooleanFormat.vue?vue&type=script&lang=js"
export * from "./BooleanFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports